module.exports = __webpack_public_path__ + "static/media/P38.d9347604.jpg";